import { render, staticRenderFns } from "./settings_page.vue?vue&type=template&id=544a5c42&"
import script from "./settings_page.vue?vue&type=script&lang=js&"
export * from "./settings_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports